import React from 'react'
import Fieldset from 'layouts/form/Fieldset'
import * as Fields from 'support/fields'
import { CardWithHeader } from 'ui/cards'
import { Translation, Translator } from '@morningtrain/react-translations'
import { useValue } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'
import {useField} from "@morningtrain/react-fields";

function GuestCount (props) {
  const field = useField(props)
  const normFromGuestCountModel = useValue('norm_from_guest_count', field.isNorm)

  const [normFromGuestCount, setNormFromGuestCount] = React.useState(normFromGuestCountModel)

  React.useEffect(() => {
    setNormFromGuestCount(normFromGuestCount)
  }, [normFromGuestCountModel])

  const header = (
    <>
      <Translation name='headings.guest_count' />
      <Fields.Checkbox
        onChange={setNormFromGuestCount}
        name='norm_from_guest_count'
        label={<Translation name='fields.norm_from_guest_count.label' />}
      />
    </>
  )

  const content = () => {
    if (!normFromGuestCount) {
      return null
    }

    return (
      <Fieldset cols={3}>
        <Fields.Number
          name='norm_from_guest_count_factor'
          label={<Translation name='fields.norm_from_guest_count_factor.label' />}
          defaultValue={1}
        />
        <Fields.Number
          name='norm_from_guest_count_factor_usage_percentage'
          label={<Translation name='fields.norm_from_guest_count_factor_usage_percentage.label' />}
          defaultValue={100}
        />
        <Fields.Number
          name='norm_from_guest_count_buffer'
          label={<Translation name='fields.norm_from_guest_count_buffer.label' />}
          defaultValue={0}
        />
      </Fieldset>
    )
  }

  return (
    <CardWithHeader header={header}>
      {content()}
    </CardWithHeader>
  )
}

export default observer(GuestCount)
